import * as v from 'valibot';
export const weekdaysSchema = v.pipe(v.string(), 
// a string with seven 0 or 1, one for each weekday
v.regex(/^[01]{7}$/, (v) => 'expected weekdays, got ' + v.input), v.transform((s) => ({
    monday: p(s[0]),
    tuesday: p(s[1]),
    wednesday: p(s[2]),
    thursday: p(s[3]),
    friday: p(s[4]),
    saturday: p(s[5]),
    sunday: p(s[6]),
})));
export const initialWeekdays = {
    monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true, sunday: true
};
function p(c) {
    switch (c) {
        case '1': return true;
        default: return false;
    }
}
export function prettyWeekdays(w) {
    return [w.monday ? '1' : '0',
        w.tuesday ? '1' : '0',
        w.wednesday ? '1' : '0',
        w.thursday ? '1' : '0',
        w.friday ? '1' : '0',
        w.saturday ? '1' : '0',
        w.sunday ? '1' : '0'].join('');
}
